export enum NotificationTemplates {
  TeacherMentioned = "TeacherMentioned",
  StudentMentioned = "StudentMentioned",
  ProjectTaskResourcesAdded = "ProjectTaskResourcesAdded"
}
